// src/component/feedback/FeedbackStatusChip.js
import { Chip } from '@mui/material';
import { FEEDBACK_STATUS_META } from '../../constans/feedback';

/**
 * Renders a status chip for feedback tickets with consistent colouring.
 */
export default function FeedbackStatusChip({ status, size = 'small', sx = {}, ...rest }) {
  const meta = FEEDBACK_STATUS_META[status] || {
    label: status ? String(status) : 'Unknown',
    chipColor: 'default',
    background: 'rgba(0,0,0,0.08)',
  };

  return (
    <Chip
      size={size}
      label={meta.label}
      color={meta.chipColor === 'default' ? 'default' : meta.chipColor}
      sx={{
        bgcolor: meta.chipColor === 'default' ? meta.background : undefined,
        color: meta.chipColor === 'default' ? 'text.primary' : undefined,
        fontWeight: 600,
        textTransform: 'capitalize',
        ...sx,
      }}
      {...rest}
    />
  );
}
